import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest, obj=auth
  const [wedding, setWedding] = useState(null);
  const [entitlements, setEntitlements] = useState(null);
  const [refreshTick, setRefreshTick] = useState(0);

  const loadMe = useCallback(async () => {
    const token = localStorage.getItem("token");
    if (!token) { setUser(false); return false; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      localStorage.removeItem("token");
      setUser(false);
      return false;
    }
  }, []);

  useEffect(() => { loadMe(); }, [loadMe]);

  const loadWedding = useCallback(async () => {
    try {
      const { data } = await api.get("/weddings/current");
      setWedding(data.wedding ? data : null);
    } catch { setWedding(null); }
  }, []);

  const loadEntitlements = useCallback(async (wid) => {
    if (!wid) { setEntitlements(null); return; }
    try { const { data } = await api.get(`/weddings/${wid}/entitlements`); setEntitlements(data); }
    catch { setEntitlements(null); }
  }, []);

  useEffect(() => {
    if (user && user.wedding_id) loadWedding();
    else setWedding(null);
  }, [user, loadWedding, refreshTick]);

  useEffect(() => {
    const wid = wedding?.wedding?.id;
    if (wid) loadEntitlements(wid);
  }, [wedding, loadEntitlements, refreshTick]);

  const login = async (email, password, code = "") => {
    const { data } = await api.post("/auth/login", { email, password, code });
    localStorage.setItem("token", data.token);
    const me = await loadMe();
    return me || data;
  };
  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("token", data.token);
    const me = await loadMe();
    return me || data;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("token");
    setUser(false); setWedding(null);
  };

  const refreshWedding = () => setRefreshTick((t) => t + 1);
  const hasFeature = (key) => !!entitlements?.features?.[key]?.allowed;

  return (
    <AuthCtx.Provider value={{ user, wedding, entitlements, premium: entitlements?.premium, hasFeature,
      login, register, logout, loadMe, refreshWedding, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}
